"use strict";module.exports=function(r){return Array.isArray(r)?r[0]:r};
